import { ReactNode } from "react"
import { useStore } from "../../contexts/store"
import { useLocation } from "wouter"
import { Box, Button } from "@mui/material"


const NavigationButton = ({badge, icon, label, to, variant="inactive"}: {active?: boolean, badge?: ReactNode, icon: ReactNode, label: string, to: string, variant?: "active"|"inactive"|"activeParent"|"activeChild"}) => {
  const { podStore, uiStore } = useStore()
  const [location, navigate] = useLocation()

  function handlePodNavigation() {
    navigate(to, { state: { prevUrl: location } })
    podStore.clearSearch()
    uiStore.setSidebarIsOpen(false)
  }

  return (
    <Button
      fullWidth
      onClick={handlePodNavigation}
      sx={{
        alignContent: "center",
        backgroundColor: variant === "active" ? "primary.light" : "",
        border: "1px solid",
        borderColor: variant === "active" ? "primary.main" : "back.main",
        borderRadius: "10px",
        display: "grid",
        gap: "15px",
        gridTemplateColumns: badge ? "min-content auto max-content" : "min-content auto",
        justifyContent: "start",
        textTransform: 'none'
      }}
    >
      <Box sx={{
        backgroundColor: variant === "activeParent" ? "primary.main" : "white",
        borderRadius: "12px",
        color: variant === "active" ? "primary.main" : (variant === "activeParent" ? "white" : "primary.light"),
        display: "grid",
        padding: "6px"
      }}>
        {icon}
      </Box>
      <Box sx={{
        color: variant === "active" ? "textcolor.dark" : (variant === "activeParent" ? "textcolor.main" : "textcolor.light"),
        fontSize: "13px",
        textAlign: "start",
        maxHeight:'34px',
        lineHeight:'15px',
        wordBreak: "break-word",
        overflow:'hidden'
      }}>
        {label}
      </Box>
      {badge !== undefined &&
        badge
      }
    </Button>
  )
}

export default NavigationButton